module.exports = __webpack_public_path__ + "img/jianzhu_icon.faf7adaf.png";